import { render, staticRenderFns } from "./DeleteCloudRecordings.vue?vue&type=template&id=7b4fbaac"
import script from "./DeleteCloudRecordings.vue?vue&type=script&lang=js"
export * from "./DeleteCloudRecordings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports